import { FooterLayout } from '../../components/Footer/Footer'

const Terms = () => {
  return (
    <>
      <div class='bg-gray-100 text-[#9c0343] leading-10 font-inter'>
        <div class='container mx-auto px-56 py-8 '>
          <h1 class='mt-10 mb-16 text-center font-medium'>Điều khoản dịch vụ</h1>

          <p class='text-xl leading-10 mb-4'>
            Chính sách bảo mật này quy định cách trang web của chúng tôi sử dụng và bảo vệ bất kỳ thông tin nào bạn cung
            cấp cho chúng tôi khi bạn sử dụng trang web này.
          </p>

          <h2 class='font-medium mb-5 mt-10'>Thông tin chúng tôi thu thập</h2>

          <p class='text-xl leading-10 mb-4'>Chúng tôi có thể thu thập những thông tin sau:</p>

          <ul class='text-xl list-disc list-inside mb-6 ml-10'>
            <li class='leading-10'>Tên và thông tin liên hệ của bạn</li>
            <li class='leading-10'>Thông tin khác liên quan đến khảo sát khách hàng và/hoặc ưu đãi</li>
          </ul>

          <h2 class='font-medium mb-5 mt-10'>Cách chúng tôi sử dụng thông tin</h2>

          <p class='text-xl leading-10 mb-4'>
            Chúng tôi yêu cầu thông tin này để hiểu nhu cầu của bạn và cung cấp cho bạn dịch vụ tốt hơn và đặc biệt vì
            những lý do sau đây:
          </p>

          <ul class='text-xl list-disc list-inside mb-6 ml-10'>
            <li class='leading-10'>Lưu trữ dữ liệu nội bộ</li>
            <li class='leading-10'>Cải thiện chất lượng dịch vụ của chúng tôi</li>
            <li class='leading-10'>
              Đôi khi, chúng tôi cũng có thể sử dụng thông tin của bạn để liên hệ với bạn cho mục đích nghiên cứu thị
              trường, khảo sát nghiên cứu khách hàng. Chúng ta có thể liên hệ với bạn qua email, điện thoại hoặc thư.
              Chúng tôi có thể sử dụng thông tin để tùy chỉnh nội dung trang web theo nhu cầu của bạn.
            </li>
          </ul>

          <h2 class='font-medium mb-5 mt-10'>Bảo mật</h2>

          <p class='text-xl  leading-10 mb-4'>
            Chúng tôi cam kết đảm bảo rằng thông tin của bạn được an toàn. Để ngăn chặn truy cập trái phép hoặc tiết lộ
            thông tin, chúng tôi đã áp dụng các thủ tục vật lý, điện tử và quản lý phù hợp để bảo vệ và bảo mật thông
            tin chúng tôi thu thập trực tuyến.
          </p>

          <h2 class='font-medium mb-5 mt-10'>Cookie</h2>

          <p class='text-xl leading-10 mb-4'>
            Cookie là một tệp nhỏ yêu cầu quyền đặt vào ổ cứng máy tính của bạn. Một khi bạn đồng ý, tệp được thêm vào
            và cookie giúp phân tích lưu lượng truy cập web hoặc cho bạn biết khi bạn truy cập một trang web cụ thể.
            Cookie cho phép các ứng dụng web phản hồi lại bạn với tư cách cá nhân. Ứng dụng web có thể điều chỉnh nó
            hoạt động theo nhu cầu, sở thích và không thích của bạn bằng cách thu thập và ghi nhớ thông tin về sở thích
            của bạn.
          </p>

          <p class='text-xl  leading-10 mb-4'>
            Nhìn chung, cookie giúp chúng tôi cung cấp cho bạn một trang web tốt hơn bằng cách cho phép chúng tôi giám
            sát những trang bạn tìm thấy hữu ích còn bạn thì không. Cookie không hề cho phép chúng tôi truy cập vào máy
            tính của bạn hoặc bất kỳ thông tin nào về bạn, ngoài dữ liệu bạn chọn chia sẻ với chúng tôi.
          </p>

          <h2 class='font-medium mb-5 mt-10'>Liên kết tới các trang web khác</h2>

          <p class='text-xl  leading-10 mb-4'>
            Trang web của chúng tôi có thể chứa các liên kết đến các trang web khác mà bạn quan tâm. Tuy nhiên, một khi
            bạn đã sử dụng các liên kết này để rời khỏi trang web của chúng tôi, bạn nên lưu ý rằng chúng tôi không có
            bất kỳ quyền kiểm soát nào đối với trang web khác đó. Vì vậy, chúng ta không thể trở thành chịu trách nhiệm
            bảo vệ và quyền riêng tư của bất kỳ thông tin nào bạn cung cấp khi truy cập các trang web đó và những trang
            web như vậy không chịu sự điều chỉnh của tuyên bố về quyền riêng tư này. Bạn nên thận trọng và xem xét quyền
            riêng tư tuyên bố áp dụng cho trang web được đề cập.
          </p>

          <h2 class='font-medium mb-5 mt-10'>Kiểm soát thông tin cá nhân của bạn</h2>

          <p class='text-xl leading-10 mb-4'>
            Bạn có thể chọn hạn chế việc thu thập hoặc sử dụng thông tin cá nhân của mình theo những cách sau:
          </p>

          <ul class='text-xl list-disc list-inside mb-4 ml-10'>
            <li class='leading-10'>
              Chúng tôi sẽ không bán, phân phối hoặc cho thuê thông tin cá nhân của bạn cho bên thứ ba trừ khi chúng tôi
              có phép hoặc được pháp luật yêu cầu phải làm như vậy.
            </li>
            <li class='leading-10'>Bạn có thể yêu cầu chi tiết thông tin cá nhân mà chúng tôi lưu giữ về bạn.</li>
            <li class='leading-10'>
              Nếu bạn cho rằng bất kỳ thông tin nào chúng tôi đang cung cấp cho bạn là không chính xác hoặc không đầy
              đủ, vui lòng gửi email cho chúng tôi. Chúng tôi sẽ nhanh chóng xác thực và chỉnh sửa bất kỳ thông tin nào
              được phát hiện là không đúng.
            </li>
          </ul>

          <p class='text-xl leading-10 mb-4'>Chính sách bảo mật này có thể thay đổi mà không cần thông báo.</p>
        </div>
      </div>
      <FooterLayout />
    </>
  )
}

export default Terms
